<div class="footerBackgroud pb-3">
    <div class="container newTOCrypto propotion" style="margin: auto;">
        <div class="row pt-4">
            <p class="newTOCryptoFont">NEW TO CRYPTO? <a href="https://www.ducatuscoins.com/"
                    style="text-decoration: none; color: #000;" target="_blank"><button class="learnMoreBtn"
                        style="font-weight: 500; border: 1px solid grey;"> Learn More</button></a></p>
        </div>
    </div>

    <div class="container propotion">
        <div class="row">
            <div class="col-1"></div>
            <div class="col-10">
                <p class="footparafont">
                    <br>
                    Legal Disclaimer
                    <br>
                    Important Notice: https://property.ducatus.com is owned by Centurion Marketing Inc. ("Centurion
                    Marketing" or the "Company"), with its registered office at Torre Advanced Building 1/F Ricardo
                    Arias St., Republic of Panama. By visiting this site, you agree to be bound by Centurion Marketing's
                    Terms of Use and Privacy Policy. Digital assets offered by Centurion Marketing are intended for
                    qualified buyers who understand and accept the risks associated with the ownership of such digital
                    assets. Each buyer is advised to conduct his/her own due diligence as none of Centurion Marketing or
                    its affiliates provides any investment advice, business advice or tax or legal advice.
                    <br>
                    <br>
                    THE INFORMATION PROVIDED ON THIS SITE IS NOT FOR CIRCULATION, DISPLAY, RECEPTION OR DISTRIBUTION IN
                    SINGAPORE (INCLUDING TO THE PUBLIC OR ANY SECTION OF THE PUBLIC IN SINGAPORE) OR ANY OTHER
                    JURISDICTION WHERE THE PRODUCTS OR SERVICES OF CENTURION MARKETING OR ITS AFFILIATES WOULD BE
                    PROHIBITED WITHOUT A REQUISITE LICENSE OR EXEMPTION. NEITHER CENTURION MARKETING NOR ANY OF ITS
                    AFFILIATES HEREBY OFFER ANY SERVICE THAT WOULD CONSTITUTE A PAYMENT SERVICE FOR PURPOSES OF THE
                    SINGAPORE PAYMENT SERVICES ACT 2019, OR ANY OTHER ACTIVITY SUBJECT TO REGULATION BY THE MONETARY
                    AUTHORITY OF SINGAPORE, IN SINGAPORE OR TO ANY PERSON IN SINGAPORE.
                </p>

                <br>
                <br>

                <div class="row">
                    <div class="col-lg-3 col-md-3 col-sm-12 no-gutters">
                        <div><img [src]="'assets/footer_logo.png'" class="redoimg" [routerLink]="['/']"
                                (click)="movePageTop()" routerLinkActive="router-link-active" /></div>
                        <div class="row mt-3 no-gutters">
                            <div class="col d-flex">
                                <a href="https://www.facebook.com/sanjay.bhoola.35" target="_blank"><img
                                        [src]="'assets/facebook.svg'" class="socialMedia" style=" padding: 2px;" /></a>
                                <a href="https://www.instagram.com/ducatusproperty/" target="_blank">
                                    <img [src]="'assets/instagram white round.svg'" class="socialMedia"
                                        style="padding: 2px;" />
                                </a>
                                <p class="testtext" style="padding-left: 5px; padding-top: 5px; font-size: small;">©
                                    2021 Ducatus</p>
                            </div>
                            <!-- <div class="col">
                               
                            </div> -->
                        </div>
                    </div>
                    <div class=" col-lg-3 col-md-3 col-sm-12 testtext">
                        <ul style="list-style-type:none;">
                            <!-- <li>About</li> -->
                            <li class="lmarg"><a href="#aboutDucatusGroup"
                                    style="text-decoration: none; color: #ffffff;">About
                                    Ducatus</a></li>
                            <li class="lmarg"><a [routerLink]="['/contact']" (click)="movePageTop()"
                                    style="text-decoration: none; color: #ffffff;">Contact</a></li>
                            <li class="lmarg"><a [routerLink]="['/legal']" (click)="movePageTop()"
                                    style="text-decoration: none; color: #ffffff;">Legal</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 testtext">
                        <ul style="list-style-type:none;">
                            <li> <a href="https://www.facebook.com/DucatusCafeSG" target="_blank"
                                    style="text-decoration: none; color: white;">Ducatus Cafe</a></li>
                            <!-- <li data-toggle="tooltip" data-placement="top" title="Coming soon" style="cursor: pointer;">
                                Ducatus Cafe</li> -->
                            <li> <a href="https://charity.ducatus.com/" target="_blank"
                                    style="text-decoration: none; color: white;">Ducatus Charity</a></li>
                            <!-- <li> <a href="https://health.ducatus.net/" target="_blank"
                                    style="text-decoration: none; color: white;">Ducatus Health and Beauty</a></li> -->
                            <li> <a href="https://travel.ducatus.com/" target="_blank"
                                    style="text-decoration: none; color: white;">Ducatus Travel</a></li>
                        </ul>
                    </div>
                    <div class="col-lg-3 col-md-3 col-sm-12 testtext">
                        <ul style="list-style-type:none;">
                            <li><a href="https://www.merchants.ducatus.com/" target="_blank"
                                    style="text-decoration: none; color: white;">Ducatus Merchants</a></li>
                            <li><a href="https://remusnation.com" target="_blank"
                                    style="text-decoration: none; color: white;">Remusnation</a></li>
                            <li>
                                <a href="https://d-pog.com/" target="_blank"
                                    style="text-decoration: none; color: white;">Proof of Gold</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-1"></div>
        </div>
    </div>
</div>